<template>
<el-container>
   <el-dialog
      title="编辑楼层"
      :modal-append-to-body="false"
      :lock-scroll="false"
      :visible.sync="editFloorVisible"
      width="400px"
    >
    <el-form
      :inline="true"
      :model="editFloorForm"
      ref="editFloorForm"
      class="demo-ruleForm"
    >
    <el-form-item label="楼层名称" label-width="120px">
       <el-input type="text" v-model="editFloorForm.floorName" placeholder="请输入楼层名称"  style="width:200px" show-word-limit></el-input>   
    </el-form-item>
    <div style="margin-top: 10px;">
      <el-button type="primary" @click="confirmEditFloor">{{$t("apartmentRoomDetail.confirmChoose")}}</el-button>
      <el-button type="primary" @click="editFloorVisible = false;">{{ $t("apartmentRoomDetail.cancel") }}</el-button>
    </div>
    </el-form>
  </el-dialog>  
  <el-dialog
      title="添加楼层"
      :modal-append-to-body="false"
      :lock-scroll="false"
      :visible.sync="addFloorVisible"
      width="400px"
    >
    <el-form
      :inline="true"
      :model="addFloorForm"
      ref="addFloorForm"
      class="demo-ruleForm"
    >
    <el-form-item label="名称前缀" label-width="120px">
       <el-input type="text" v-model="addFloorForm.floorNameTxt" placeholder="请输入楼层名称前缀"  style="width:200px" show-word-limit></el-input>   
    </el-form-item>
    <el-form-item label="开始楼层" label-width="120px">
       <el-input type="number" v-model="addFloorForm.beginNum" placeholder="开始楼层"  style="width:200px" show-word-limit></el-input>   
    </el-form-item>
    <el-form-item label="结束楼层" label-width="120px">
       <el-input type="number" v-model="addFloorForm.endNum" placeholder="结束楼层"  style="width:200px" show-word-limit></el-input>   
    </el-form-item>
    <!-- <el-form-item label="不包括" label-width="120px">
       <el-input type="text" v-model="addFloorForm.notIncludTxt" placeholder="请输入不包括楼层如2,3"  style="width:200px" show-word-limit></el-input>   
    </el-form-item> -->

    <div style="margin-top: 10px;">
      <el-button type="primary" @click="confirmAddFloor">{{$t("apartmentRoomDetail.confirmChoose")}}</el-button>
      <el-button type="primary" @click="addFloorVisible = false;">{{ $t("apartmentRoomDetail.cancel") }}</el-button>
    </div>
    </el-form>
  </el-dialog>  
  <el-main>
   <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>楼栋信息</span>
        <el-button type="primary" style="float: right;margin-top:-10px" @click="addFloor();">添加楼层</el-button>
        <!-- <el-button type="primary" style="float: right;" @click="editBtn">添加房间</el-button> -->
      </div>
       <el-form :inline="true" ref="selectForm" class="demo-ruleForm">
         <el-form-item label="楼栋编号:" style="width:200px">
            {{this.buildingData.buildingNo}}
         </el-form-item>
         <el-form-item label="楼栋名称:" style="width:200px">
            {{this.buildingData.buildingName}}
         </el-form-item>  
          <el-form-item label="楼层个数:" style="width:200px">
            {{this.buildingData.floorCount}}
         </el-form-item> 
          <el-form-item label="楼栋性质:" style="width:200px">
            {{this.buildingData.sort==0?'混合楼':this.buildingData.sort==1?'男生楼':this.buildingData.sort==0?'女生楼':''}}
         </el-form-item>   
        
       
     </el-form>
   </el-card>
   <el-card class="box-card" style="margin-top:15px" v-show="apartmentType=='1'||apartmentType=='2'">
     <div slot="header" style="height:40px;line-height: 40px;">
        <span>{{$t('apartmentDetail.roomInfo')}}</span>
        <!-- <el-button-group style="float: right; padding: 3px 0">
          <el-button type="primary" icon="el-icon-plus" @click="addRoomFSSVisible=true">{{$t('apartmentDetail.addRoom')}}</el-button>
        </el-button-group> -->
     </div>
     <div v-for="b in buildings" :key="b.buildingId" class="text item" v-show="buildings.length>0">
          <el-container>
            <!-- <el-header
              style="text-align: center;height:40px;line-height: 40px;border:solid 1px #888888;"
            >{{b.buildingName}}</el-header>-->
            <el-main style="text-align: center;">
              <div v-for="f in floors" :key="f.floorId" class="text item">
                <el-container>
                  <el-aside style="overflow-x:hidden;margin-top:2px;width:100px;border:solid 1px #888888;display:flex;justify-content:center;align-items:center;">
                     <el-form>
                    <el-row style="width:90px">
                       <el-col :span="24" style="word-wrap:break-word;">{{f.floorName}}</el-col>
                    </el-row>
                    <el-row>
                       <el-col :span="24">
                        <el-button :title="$t('apartmentDetail.deleteFloor')" @click="delFloor(f)" size="mini" style="color:red;margin-left:3px" icon="el-icon-delete"></el-button>
                       </el-col>   
                     </el-row>
                     </el-form>
                  </el-aside>
                  <el-main>
                    <div v-for="r in f.roomList" :key="r.roomId" class="text item">
                      <el-col :span="8" style="height:60px">
                          <el-input :placeholder="$t('apartmentDetail.roomName')" v-model="r.roomName" style="width:80%">
                          <el-button slot="append" :title="$t('apartmentDetail.save')" @click="saveRoom(r)" style="color:blue;width:30px" icon="el-icon-folder-checked"></el-button>
                          <el-button slot="append" :title="$t('apartmentDetail.delete')" @click="delRoom(r)" style="color:red;" icon="el-icon-delete"></el-button>
                        </el-input>
                      </el-col>
                    </div>
                    <el-col :span="8" style="display:flex;justify-content:center;align-items:center;">
                      <div style="border:1px dashed #eee;width:80%;height:45px;display:flex;justify-content:center;align-items:center;">
                         <el-button icon="el-icon-plus">添加房间</el-button>
                      </div>
                    </el-col>  
                  </el-main>
                </el-container>
              </div>   
          </el-main>
       </el-container>
      </div>  
      <div v-show="buildings.length==0" style="width:100%;height:100px;display:flex;justify-content:center;align-items:center;">
       没有楼层信息
      </div>  
    </el-card> 

    <el-card class="box-card" style="margin-top:15px" v-show="apartmentType=='0'">
      <div slot="header" style="height:40px;line-height: 40px;">
        <span>{{$t('apartmentDetail.roomInfo')}}</span>
        <el-button-group style="float: right; padding: 3px 0">
          <el-button type="primary" icon="el-icon-plus" @click="addRoomFSSVisible=true">{{$t('apartmentDetail.addRoom')}}</el-button>
        </el-button-group>
      </div>
      <div v-for="o in roomData" :key="o.roomId" class="text item">
        <el-col :span="6" style="height:60px">
            <el-input :placeholder="$t('apartmentDetail.roomName')" v-model="o.roomName" style="width:80%">
            <el-button slot="append" :title="$t('apartmentDetail.save')" @click="saveRoom(o)" style="color:blue;width:50px" icon="el-icon-folder-checked"></el-button>
            <el-button slot="append" :title="$t('apartmentDetail.delete')" @click="delRoom(o)" style="color:red;" icon="el-icon-delete"></el-button>
          </el-input>
        </el-col>
      </div>
    </el-card> 
  
  </el-main>
</el-container>      
</template>

<script>
import Pagings from "../common/Pagings.vue";
export default {
  name: "buildingDetail",
   data() {
     return {
        apartmentId:this.$route.query.apartmentId,
        apartmentType:this.$route.query.apartmentType,
        buildingId:this.$route.query.buildingId,
        buildingData:JSON.parse(this.$route.query.buildingData),
        buildings:[],
        floors:[],
        roomData: [], //分散型公寓的房间列表
        pageData:{
         offset: 1,
         pageNumber: 10,
         total: 0, //总条数
         floorData: [],
        },
        selectForm:{
            floorName:""
        },
        addFloorVisible:false,
        isEdit:false,
        addFloorForm:{
            floorNameTxt:"",
            floorId:"",
            beginNum:1,
            endNum:5,
            notIncludTxt:"",
        },
        addFloorTitle:"添加楼层",
        editFloorVisible:false,
        editFloorForm:{
             floorId:"",
             floorName:""
        }
     }
   },
   components: {
    Pagings
   },
   created(){
      //  this.floorPower();
      this.getApartmentDetail();
      this.roomList()
   },  
   methods: {
       addFloor(){
          this.addFloorVisible=true;
          this.addFloorForm.floorName="";
          this.isEdit=false;
          this.addFloorForm.floorId="";
          this.addFloorTitle="添加楼层";
       },
       editFloor(index,row){
         this.editFloorVisible=true;
         this.editFloorForm.floorName=row.floorName;
        //  this.isEdit=true;
         this.editFloorForm.floorId=row.floorId;
        //  this.addFloorTitle="编辑楼层";
       },
       deleteFloor(index,row){
        this.$confirm("确定删除该楼层么？",this.$t("tenant.hint"), {
          confirmButtonText: this.$t("tenant.confirm"),
          cancelButtonText: this.$t("tenant.cancel"),
          type: 'warning'
        }).then(() => {
          var formData = new FormData();
          formData.append("floorId",row.floorId);
          formData.append("isDelete",0);
          this.$server
          .exam("/customer/apartment/deleteFloor", formData)
          .then(data => {
           if (data.code == 200) {
              this.getApartmentDetail();
              this.$message({
               message: "删除楼层成功",
               type: "success"
              });
             
            } else {
              this.$message({
               message: data.message,
               type: "warning"
              });
            }
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: this.$t("tenant.cancelDelete")
          });          
        });  
       },

       confirmEditFloor(){
          var floorName=this.editFloorForm.floorName;
           if(floorName==""||floorName==null){
             this.$message({
               message: "请输入楼层名称",
               type: "warning"
              });
             return false;
          }

           var formData = new FormData();
            formData.append("floorId",this.editFloorForm.floorId);
            formData.append("floorName",this.editFloorForm.floorName);
            this.$server
            .exam("/customer/apartment/editFloor", formData)
            .then(data => {
              if (data.code == 200) {
                this.editFloorVisible=false;
                 this.getApartmentDetail();
                this.$message({
                 message: "修改楼层成功",
                 type: "success"
                });
              } else {
                this.$message({
                 message: data.message,
                 type: "warning"
                });
              }
            });

       },
       confirmAddFloor(){
          var floorNameTxt=this.addFloorForm.floorNameTxt;
          var beginNum=this.addFloorForm.beginNum;
          var endNum=this.addFloorForm.endNum;
          var notIn=this.addFloorForm.notIncludTxt;
          var floorNameList=[];
          if(floorNameTxt==""||floorNameTxt==null){
             this.$message({
               message: "请输入楼层名称前缀",
               type: "warning"
              });
             return false;
          }
          if(beginNum==""||beginNum==null){
             this.$message({
               message: "请输入开始楼层",
               type: "warning"
              });
             return false;
          }
           if(endNum==""||endNum==null){
             this.$message({
               message: "请输入结束楼层",
               type: "warning"
              });
             return false;
          }
          if(notIn!=""&&notIn!=null){
            var strNot=notIn.split(',');
             alert(notIn);
            //  for(var j=0;j=strNot.length;j++){
            //    alert(strNot[j]);
              //  for(var i=beginNum;i<endNum;i++){
              //    if(strNot[j]!=i){
              //      floorNameList.push(floorNameTxt+i);
              //    }
              //   }
            // }
          }else{
            for(var i=beginNum;i<=endNum;i++){
              floorNameList.push(floorNameTxt+i);
            }
          }
           var formData = new FormData();
            formData.append("apartmentId",this.apartmentId);
            formData.append("buildingId",this.buildingId);
            formData.append("floorNameList",JSON.stringify(floorNameList));
            this.$server
            .exam("/customer/apartment/addApartmentFloors", formData)
            .then(data => {
              if (data.code == 200) {
                this.addFloorVisible=false;
                this.getApartmentDetail();
                this.$message({
                 message: "添加楼层成功",
                 type: "success"
                });
              } else {
                this.$message({
                 message: data.message,
                 type: "warning"
                });
              }
            });
       },

      delFloor(floorData){
       this.$confirm(this.$t("apartmentDetail.deleteFloor-confirm1")+floorData.floorName+this.$t("apartmentDetail.deleteFloor-confirm2"), this.$t("apartmentDetail.hint"), {
          confirmButtonText: this.$t("apartmentDetail.confirm"),
          cancelButtonText:  this.$t("apartmentDetail.cancel"),
          type: 'warning'
        }).then(() => {
         var formData = new FormData();
         formData.append("floorId ", floorData.floorId );
         this.$server
        .exam("/customer/apartment/deleteFloor ", formData)
        .then(data => {
          this.addFloorVisible=false;
          if (data.code == 200) {
             this.$message({
              message: data.message,
              type: "success"
             });
             this.getApartmentDetail();
           } else {
             this.$message({
              message: data.message,
              type: "warning"
             });
           }
         });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: this.$t("apartmentDetail.alreadyDelete")
          });          
        });
    },
    saveRoom(roomData){
       var formData = new FormData();
       formData.append("roomId", roomData.roomId);
       formData.append("roomName", roomData.roomName);
       this.$server
        .exam("/customer/apartment/editApartmentRoom", formData)
        .then(data => {
          this.addFloorVisible=false;
          if (data.code == 200) {
             this.$message({
              message: data.message,
              type: "success"
            });
            this.getApartmentDetail(); 
          } else {
            this.$message({
              message: data.message,
              type: "warning"
            });
          }
        });
    },
    delRoom(roomData){
       this.$confirm(this.$t("apartmentDetail.deleteRoom-confirm1")+roomData.roomName+this.$t("apartmentDetail.deleteRoom-confirm2"), this.$t("apartmentDetail.hint"), {
          confirmButtonText: this.$t("apartmentDetail.confirm"),
          cancelButtonText:this.$t("apartmentDetail.cancel"),
          type: 'warning'
        }).then(() => {
          var formData = new FormData();
          formData.append("roomId", roomData.roomId);
          this.$server
          .exam("/customer/apartment/deleteRoom", formData)
          .then(data => {
            this.addFloorVisible=false;
            if (data.code == 200) {
             this.$message({
              message: data.message,
              type: "success"
            });
            this.getApartmentDetail();
          } else {
             this.$message({
              message: data.message,
              type: "warning"
             });
          }
        });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: this.$t("apartmentDetail.alreadyDelete")
          });          
        });
    },
      
    roomList() {
      var formData = new FormData();
      formData.append("apartmentId",this.$route.query.apartmentId);
      this.$server
        .exam("/customer/apartment/listRoom", formData)
        .then(data => {
          if (data.code == 200) {
            this.roomData = data.data;
          } else {
            this.$message({
              message: data.message,
              type: "warning"
            });
          }
        });
    },
      
    getApartmentDetail() {
         var formData = new FormData();
         formData.append("apartmentId", this.$route.query.apartmentId);
         // if (this.formApartment.selectBuliding != "") {
         //   formData.append("buildingId", this.formApartment.selectBuliding);
         // }
         this.$server
          .exam("/customer/apartment/listApartmentBuilding", formData)
          .then(data => {
           if (data.code == 200) {
             var apmData = data.data;
             this.buildings = apmData;
             for (var str in apmData) {
              var bldData = apmData[str];
              var floorData = bldData.floorList;
              this.floors = bldData.floorList;
             }
           } else {
            this.$message({
              message: data.message,
              type: "warning"
            });
           }
         });
       },
      
       floorPower(){
          var formData = new FormData();
          formData.append("apartmentId",this.apartmentId);
          formData.append("buildingId",this.buildingId);
          formData.append("pageNo", this.pageData.offset);
          formData.append("pageSize", this.pageData.pageNumber);
          this.$server
          .exam("/customer/apartment/listFloors", formData)
          .then(data => {
           if (data.code == 200) {
             this.pageData.floorData = data.data.records;
             this.pageData.total = data.data.total;
            } else {
              this.$message({
               message: data.message,
               type: "warning"
              });
            }
         });
       },

     floorHandleSizeChange(val) {
       this.pageData.pageNumber = val;
       this.floorPower();
     },
     floorHandleCurrentChange(val) {
       this.pageData.offset = val;
       this.floorPower();
     },
   }         
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/building/buildingDetail.vue